<template>
    <div class="DoughCalculator">
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="DoughCalculator__Data">
                    <div class="row">
                        <div class="col-12">
                            <h3>What do you want to make?</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 d-flex align-items-center">
                            <label for="">Number of Pizzas</label>
                        </div>
                        <div class="col-4">
                            <input type="number" v-model="nr_doughs" min="0">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 d-flex align-items-center">
                            <label for="">Dough Ball Weight (grams)</label>
                        </div>
                        <div class="col-4">
                            <input type="number" v-model="dough_weight" min="0">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 d-flex align-items-center">
                            <label for="">Water Percentage (%)</label>
                        </div>
                        <div class="col-4">
                            <input type="number" v-model="water_percentage" min="0">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="DoughCalculator__Result">
                    <div class="row">
                        <div class="col-12">
                            <h3>This is what you will need:</h3>
                            <ul>
                                <li>
                                    <strong>Flour :</strong>
                                    {{flour}}
                                    grams</li>
                                <li>
                                    <strong>Water :</strong>
                                    {{water}}
                                    grams</li>
                                <li>
                                    <strong>Salt :</strong>
                                    {{salt}}
                                    grams</li>
                                <li>
                                    <strong>Fresh Yeast:</strong>
                                    {{yeast}}
                                    grams</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      water_percentage: 65,
      nr_doughs: 2,
      dough_weight: 200
    };
  },
  computed: {
    flour: function() {
      let a = this.nr_doughs * this.dough_weight;
      let b = this.water_percentage / 100;
      let c = 1 + b + 0.03 + 0.002;
      let d = a / c;
      return d.toFixed(1);
      return Math.round(d * 100) / 100;
    },
    water: function() {
      let num = this.flour * this.water_percentage / 100;

      return num.toFixed(1);
    },
    salt: function() {
      let num = 0.03 * this.flour;
      return num.toFixed(1);
    },
    yeast: function() {
      let num = 0.002 * this.flour;
      return num.toFixed(1);
    }
  }
};
</script>
